export const getEnumKeysAsArray = (EnumType: any) => Object.keys(EnumType).filter((key) => !isNaN(Number(key)) === false);
export const getEnumValuesAsArray = (EnumType: any): string[] => Object.values(EnumType);
